module.exports = __webpack_public_path__ + "img/hm_block03_04_tc.bf454bc9.png";